export default __webpack_public_path__ + "942713d1ec8acae895b814c2d4e4a966.svg";